import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'tiles-groups',
    component: Children,

    children: [
      {
        path: '',
        name: 'tiles-groups',
        component: () => import('../pages/TilesGroupPage.vue'),
        props: route => ({
          id: Number(route.params.id)
        })
      }
    ]
  }
];

export default routes;
